import { post, get } from '../helpers/fetchServicesMethods';
import { toast } from 'react-toastify';
import { url } from '../reducers/url';
import PubSub from 'pubsub-js';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

export const submitAnitbodySearch = async (data, history, t) => {
    // dispatch(setUser({ GQUSERID: data.GQUSERID, isLoggedIn: true }));
    // const history = useHistory();
    return post(url.antibodySearch, data, history)
        .then(async (response) => {
            if (response) {
                return response;
                // toast.success('loginSuccess');
                // dispatch(setUser({GQUSERID: data.GQUSERID,isLoggedIn: true }));
                // history.push('/home');
            } else {
                // let errorMsg = 'Unable to Login';
                // if(response && typeof response.response_content === 'object' && response.response_content !== null){
                //     errorMsg = response.response_content.message;
                // }
                // toast.error(errorMsg);
                // dispatch(setUser({isLoggedIn: false }));
            }
        })
        .catch((error) => {
            toast.error('failed');
            console.log("error::", error);

            // return dispatch(loginError(error));
            // dispatch(showMessage({ message: error }));
        });
};

async function getAuthInfoAB(workflowId, history) {

    try {
        let apiurl = url.authInfoAB;
        if (workflowId) {
            // Comes from the route URL '/antibody/parent_id={parentId}'
            let db = 'db=wf:' + workflowId + '.resdb&parentId=' + workflowId;
            apiurl = apiurl.replace('db=', db);
        }
        showLoader();
        return await get(apiurl, history)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                // toast.error('Failed to change password');
                console.log("error::", error);

            });
    } catch (error) {
        toast.error(error.response_content.message);
        console.error(error, "errors");
    }

}
const searchResAntibody = {
    submitAnitbodySearch,
    getAuthInfoAB
};

export default searchResAntibody;
